import {User} from '@hconnect/apiclient'
import {trackEvent} from '@hconnect/common/logging/Analytics'
import {Button, Box} from '@material-ui/core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'

import {JobSiteSelectionModal, useJobSiteSelectionModal} from '../../../features/rmc/orderIntake'
import {selectSelectedCustomerFilter} from '../../../Organisms/Customers/Customers.selector'
import {useRolesByCustomerId} from '../../../Roles'
import {AppState} from '../../../Root.store'
import {getUserProfile} from '../../../UserProfile/UserProfile.selectors'

interface RMCOrderActionButtonProps {
  smallScreen: boolean
  testId: string
}

export const RMCOrderActionButton: React.FC<RMCOrderActionButtonProps> = ({
  smallScreen,
  testId
}) => {
  const {t} = useTranslation()
  const selectedCustomer = useSelector((state: AppState) => selectSelectedCustomerFilter(state))
  const userProfile = useSelector<AppState, User | null>(
    (state) => getUserProfile(state).userProfile
  )
  const customerId = selectedCustomer?.customerId || ''

  const {data: roles} = useRolesByCustomerId(selectedCustomer?.customerId)

  const {
    isOpen,
    openModal,
    closeModal,
    handleJobSiteSelect,
    handleCreateNewOrder,
    handleRepeatPreviousOrder
  } = useJobSiteSelectionModal()

  const handleNewRMCDelivery = () => {
    // Track RMC order intake start event
    trackEvent('hubRmcOrderIntakeStart', {
      product: 'hub',
      customerId: selectedCustomer?.customerId,
      customerName: selectedCustomer?.customerName,
      userCountry: userProfile?.country,
      userId: userProfile?.user_id,
      role: roles.map((role) => role.roleType).join(','),
      businessLine: 'RMC',
      entryPoint: 'Orders & Deliveries'
    })

    openModal()
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
        marginBottom={smallScreen ? 0 : 1}
      >
        <Button
          onClick={handleNewRMCDelivery}
          color={smallScreen ? 'secondary' : 'inherit'}
          variant={smallScreen ? 'contained' : 'outlined'}
          style={{width: smallScreen ? '300px' : 'max-content'}}
          data-test-id={testId}
        >
          {t('order.newRmcDelivery', 'New RMC delivery')}
        </Button>
      </Box>

      <JobSiteSelectionModal
        open={isOpen}
        customerId={customerId}
        onClose={closeModal}
        onSelectSite={handleJobSiteSelect}
        onCreateNewOrder={handleCreateNewOrder}
        onRepeatPreviousOrder={handleRepeatPreviousOrder}
      />
    </>
  )
}
